import {SET_BLOG_LOCATION} from "../reducers/blogReducer";
import {catchErrorSync} from "../app/components/Common/AppErrorBoundary";


export const setBlogLocation = (location) => catchErrorSync(dispatch => {
    dispatch({
        type: SET_BLOG_LOCATION,
        payload: location
    })
});

export const resetBlogLocation = () => catchErrorSync(dispatch => {
    dispatch({
        type: SET_BLOG_LOCATION,
        payload: null
    })
});
